
import { Component, Prop, Vue } from "vue-property-decorator";
import KeyGuestsTable from "@/components/keys/guests/KeyGuestsTable.vue";

@Component({
  components: { KeyGuestsTable },
})

export default class GuestsTab extends Vue {

  @Prop({ default: null })
  public entityType: "keys"|"keyGroups"|"nonTransferables";

  @Prop({ default: null })
  public entityId: number;
}
